import React from 'react';
import DatePicker from 'react-date-picker';
import { useField, useFormikContext } from 'formik';
import './_datePicker.scss';

function DatePickerInput (props) {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);

  return (
    <div>
      <DatePicker
        {...field}
        value={field?.value ? new Date(field?.value) : null}
        onChange={(val) => {
          setFieldValue(field.name, val);
        }}
      />
    </div>
  );
}

export default DatePickerInput;
